import { createClient } from '@supabase/supabase-js';

// Load Supabase credentials from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Validate that environment variables are set
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables. Please check your .env file.');
}

// Create Supabase client for client-side operations
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storageKey: 'fusion-mart-auth',
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Service role key (for admin operations - should be used server-side only)
// Note: In production, this should NEVER be exposed in client-side code
// For now, we'll use it for admin operations, but ideally these should be done via API routes
// Using a different storage key to avoid conflicts with the main client
export const supabaseAdmin = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storageKey: 'fusion-mart-admin-auth',
    autoRefreshToken: false,
    persistSession: false,
    detectSessionInUrl: false
  }
});

// Storage bucket names
export const STORAGE_BUCKETS = {
  PRODUCT_IMAGES: 'product-images',
  BANNER_IMAGES: 'banner-images',
  HERO_IMAGES: 'hero-images'
};
